import React, {useEffect, useState} from 'react'
import {Input, Button} from '@Knowledge-OTP/znk-ui-components'
import {useMutation, gql} from '@apollo/client'
import useTranslation from '../../../../i18n/useTranslation'
import {showAlert} from '../../../../common/Alert/util'
import {useDispatch} from 'react-redux'

const SendEmailRecovery = (props) => {
  const {defaultEmail} = props
  const dispatch = useDispatch()
  const {translate} = useTranslation()
  const [email, setEmail] = useState(null)
  const [error, setError] = useState(null)
  useEffect(() => {
    if (defaultEmail) setEmail(defaultEmail)
  }, [defaultEmail])
  const [getCode, {loading}] = useMutation(
    gql`
      mutation($email: String!) {
        getRecoveryPasswordCode(email: $email)
      }
    `,
  )
  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim())

  const validate = () => {
    const value = (email || '').trim()
    if (!value) {
      setError('Please enter your work email.')
      return false
    }
    if (!isValidEmail(value)) {
      setError('Please enter a valid email address.')
      return false
    }
    setError(null)
    return true
  }

  const sendRecoveryEmail = () => {
    if (!validate()) return
    getCode({
      variables: {email: (email || '').trim()},
    }).then(
      () => {
        showAlert(
          {
            text: translate(
              'login.signin.email.recoveryPassEmailSuccess',
            ),
            status: 'success',
          },
          dispatch,
        )
      },
      (error) => {
        showAlert(
          {
            text: translate(
              'login.signin.email.recoveryPassEmailError',
            ),
            status: 'error',
          },
          dispatch,
        )
        console.error(error)
      },
    )
  }

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          sendRecoveryEmail()
        }}
      >
        <p className='form-domain'>admin.zinkerz.com</p>
        <h2 className='form-heading'>
          {translate('login.signin.email.recoveryPassBigTitle')}
        </h2>
        <p className='form-sub'>
          {translate('login.signin.email.recoveryPassTitle')}
        </p>
        <div className='field'>
          <label className='field-label'>{translate('login.signin.email.label')}</label>
        <Input
          className={`field-input ${error ? 'error' : ''}`}
          name='email'
          value={email}
          placeholder={translate(`login.signin.email.placeholder`)}
          onChange={({target: {value}}) => {
            setEmail(value)
            setError(null)
          }}
        />
          <span className={`field-error ${error ? 'visible' : ''}`}>{error || ''}</span>
        </div>
        {false && (
          <div className='my-2 text-center text-error h3 w-100'>
            {translate('login.signin.email.invalid')}
          </div>
        )}
        <Button
          className='btn-primary-login w-100 mt-2'
          color='primary'
          check
          activity={loading}
          type='submit'
          label={translate('login.signin.email.recoveryPassSendEmail')}
        />
      </form>
    </div>
  )
}

export default SendEmailRecovery
